<template>
  <select class="tags" style="width:100%"></select>
</template>

<script>
  import $ from 'jquery'
  import 'select2/dist/js/select2.full'

  // Russian
  function ending (count, one, couple, more) {
    if (count % 10 < 5 && count % 10 > 0 &&
      count % 100 < 5 || count % 100 > 20) {
      if (count % 10 > 1) {
        return couple;
      }
    } else {
      return more;
    }

    return one;
  }

  const ru = {
    errorLoading: function () {
      return 'Невозможно загрузить результаты';
    },
    inputTooLong: function (args) {
      var overChars = args.input.length - args.maximum;

      var message = 'Пожалуйста, введите на ' + overChars + ' символ';

      message += ending(overChars, '', 'a', 'ов');

      message += ' меньше';

      return message;
    },
    inputTooShort: function (args) {
      var remainingChars = args.minimum - args.input.length;

      var message = 'Пожалуйста, введите ещё хотя бы ' + remainingChars +
        ' символ';

      message += ending(remainingChars, '', 'a', 'ов');

      return message;
    },
    loadingMore: function () {
      return 'Загрузка данных…';
    },
    maximumSelected: function (args) {
      var message = 'Вы можете выбрать не более ' + args.maximum + ' элемент';

      message += ending(args.maximum, '', 'a', 'ов');

      return message;
    },
    noResults: function () {
      return 'Совпадений не найдено';
    },
    searching: function () {
      return 'Поиск…';
    },
    removeAllItems: function () {
      return 'Удалить все элементы';
    }
  };

  export default {
    name: 'tags-input',
    props: {
      placeholder: String,
      selection: Array
    },

    watch: {
      selection() {
        this._renderSelect();
      }
    },

    mounted() {
      const vm = this;
      const $el = $(this.$el);

      this.elem = $el.select2({
        multiple: true,
        tags: true,
        language: ru,
        data: (this.selection || []).map(v => ({
          id: v,
          text: v,
          selected: true
        })),
        dropdownCss: {
          'background': 'red',
          'display': 'none'
        },
        tokenSeparators: [',', ' '],
        theme: 'default'
      });

      this.elem.on('change', () => {
        const data = this.elem.find(':selected').toArray().map(e => e.value);
        console.log('change - 1', data);

        vm.$emit('update:selection', data);
        vm.$emit('change');
      });
    },

    destroyed() {
      $(this.$el).off().select2('destroy');
    },

    methods: {
      _renderSelect() {
        const vm = this;

        this.elem.empty();
        (this.selection || []).map(v => {
          this.elem.append(new Option(v, v, true, true));
        });

        this.elem.off('change').trigger('change').on('change', () => {
          const data = this.elem.find(':selected').toArray().map(e => e.value);
          console.log('change - 2', data);

          vm.$emit('update:selection', data);
          vm.$emit('change');
        });
      }
    }
  }

</script>

<style lang="scss">
  @import '../../../node_modules/select2/dist/css/select2.css';
  @import 'theme/layout';

</style>
